import Grid from '@mui/material/Unstable_Grid2/Grid2';
import {useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import SearchInput from '../search/SearchInput';
import Service from './Service';
import {servicesList} from './ServiceList';

export default function Services() {
	const {t} = useTranslation();
	const [search, setSearch] = useState('');
	const txtSearch = useRef<HTMLInputElement>();
	const handleChangeSearchFiled = () => {
		setSearch(txtSearch.current!.value);
	};
	
	return (
		<div className="felx flex-col space-y-6 mx-5">
			<SearchInput placeholder={t('search_service_placeholder')} inputRef={txtSearch}
			             onChange={handleChangeSearchFiled}/>
			<Grid className="-mx-5" container rowSpacing={1}>
				{
					servicesList.filter(service => {
						// @ts-ignore
						return search.length > 0 ? t(service.name).includes(search) : true;
					}).map((service) =>
						<Grid className="relative" key={service.id} xs={4}>
							<Service service={service}/>
						</Grid>)
				}
			</Grid>
		</div>
	);
}
